// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLUserPoleBetBetslipReference, selectKLUserPoleBetStatus } from '../user';

const selectKLPoleChipDetailsProps = createSelector(
  [selectKLUserPoleBetBetslipReference, selectKLUserPoleBetStatus],
  (betslipReference, status) => ({
    betslipReference,
    status,
  }),
);

export default selectKLPoleChipDetailsProps;
